<app-landing-header></app-landing-header>

<br />

<main class="main-content">
  <div class="crm mb-25">
    <div class="container-fluid">
      <div class="row">
        <div class="container">
          <br />
          <div class="row">
            <br />
            <div class="col-lg-12">
              <div class="breadcrumb-main">
                <h4
                  class="text-capitalize breadcrumb-title"
                  style="margin-top: 70px"
                >
                  <!-- Blog -->
                  {{ "blog.title" | translate }}
                </h4>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-12 col-md-12 mb-25">
                <div class="blog-card">
                  <div class="blog-card__thumbnail">
                    <a href="javascript:void(0)">
                      <img
                        [src]="post.url_img"
                        (error)="handleImageError()"
                        alt=""
                      />
                    </a>
                  </div>
                  <div class="blog-card__details">
                    <h1
                      *ngIf="translate.currentLang === 'en'"
                      class="blog-card__title text-center"
                    >
                      {{ post.title }}
                    </h1>
                    <h1
                      *ngIf="translate.currentLang === 'de'"
                      class="blog-card__title text-center"
                    >
                      {{ post.de_title }}
                    </h1>
                    <h1
                      *ngIf="translate.currentLang === 'ja'"
                      class="blog-card__title text-center"
                    >
                      {{ post.ja_title }}
                    </h1>
                    <h1
                      *ngIf="translate.currentLang === 'es'"
                      class="blog-card__title text-center"
                    >
                      {{ post.es_title }}
                    </h1>
                    <h1
                      *ngIf="translate.currentLang === 'fr'"
                      class="blog-card__title text-center"
                    >
                      {{ post.fr_title }}
                    </h1>
                    <div
                      *ngIf="translate.currentLang === 'en'"
                      class="blog-card__content"
                      [innerHTML]="sanitizeHtml(post.text)"
                    ></div>
                    <div
                      *ngIf="translate.currentLang === 'de'"
                      class="blog-card__content"
                      [innerHTML]="sanitizeHtml(post.de_text)"
                    ></div>
                    <div
                      *ngIf="translate.currentLang === 'ja'"
                      class="blog-card__content"
                      [innerHTML]="sanitizeHtml(post.ja_text)"
                    ></div>
                    <div
                      *ngIf="translate.currentLang === 'es'"
                      class="blog-card__content"
                      [innerHTML]="sanitizeHtml(post.es_text)"
                    ></div>
                    <div
                      *ngIf="translate.currentLang === 'fr'"
                      class="blog-card__content"
                      [innerHTML]="sanitizeHtml(post.fr_text)"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<app-landing-footer></app-landing-footer>
